export const WALLET_INVOICE_LIMIT = 10;
export const WALLET_TRANSACTION_LIMIT = 8;
